<template>
  <div class="loadingBlock container text-center">
    <loadingSVG class="w-full"></loadingSVG>
    <span class="text-blue font-bold text-xl mt-8">
      <slot>
        <span>{{ $t('loading') }}...</span>
      </slot>
    </span>
  </div>
</template>

<script>
import loadingSVG from '@/components/loadingSVG'

export default {
  name: 'loadingBlock',
  components: {
    loadingSVG
  }
}
</script>
